import MobileLayout from '../../layouts/MobileLayout';
import InitContent from '../shared/InitContent';

export default function MobileInitPage() {
  return (
    <MobileLayout>
      <InitContent />
    </MobileLayout>
  );
}
